import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface DrivewayAndWalksProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const DrivewayAndWalks: React.FC<DrivewayAndWalksProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [drivewayAndWalks, set_drivewayAndWalks] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Final Structure']?.['Driveway and Walks']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Final Structure': { ...b.values?.['Final Structure'], 'Driveway and Walks': [b.values?.['Final Structure']?.['Driveway and Walks']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Driveway And Walks';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(drivewayAndWalks)}
                />
            ) : (
                <MoneyBox
                    id={'drivewayAndWalks'}
                    allowNegative={false}
                    value={drivewayAndWalks}
                    onChange={(value) => set_drivewayAndWalks(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
